export default __webpack_public_path__ + "static/media/animal-example.47402869.png";